import React, { FC } from 'react'

import { useSelector } from 'react-redux'
import { channelSelector } from 'redux-store/channel/channel.selectors'
import { DefaultHeader } from './DefaultHeader/DefaultHeader'
import { ConditionalRender } from 'components/ConditionalRender/ConditionalRender'
import { NativeDefaultHeader } from './DefaultHeader/NativeDefaultHeader'
import { NativeThemedHeader } from './ThemedHeader/NativeThemedHeader'
import { ThemedHeader } from './ThemedHeader/ThemedHeader'

export const Header: FC = () => {
  const channel = useSelector(channelSelector)
  const isRootChannel = channel?.data?.isRootChannel
  const isChildOfRootChannel = channel?.data?.isChildOfRootChannel
  const isRootOrChild = isRootChannel || isChildOfRootChannel
  if (isRootOrChild) {
    return (
      <>
        <ConditionalRender mobileApp={false}>
          <ThemedHeader />
        </ConditionalRender>
        <ConditionalRender web={false}>
          <NativeThemedHeader />
        </ConditionalRender>
      </>
    )
  }
  return (
    <>
      <ConditionalRender mobileApp={false}>
        <DefaultHeader />
      </ConditionalRender>
      <ConditionalRender web={false}>
        <NativeDefaultHeader />
      </ConditionalRender>
    </>
  )
}
